<template>
  <div class="home">
    <header class="header">
      <a class="logo w-fl" href="/"> <img src="../assets/images/logo.png" alt="" /></a>
      <!--添加选择 项目下拉框 -->
      <el-select v-model="depData" placeholder="请选择项目" class="selectDep" size="small" @change="changeDepList($event)">
        <el-option v-for="item in depList" :key="item.did" :label="item.dname" :value="item.did"></el-option>
      </el-select>
      <div class="loginbar w-fr">
        <a class="break" href="javascript:location.reload();"><i class="iconfont icon-jianchagengxin"></i></a>
        <a class="role" @click="positiveDialog = true" href="javascript:;"><i class="iconfont icon-tishi"></i></a>
        <span class="username">{{ $store.state.user.userInfo.nickname }}<img src="../assets/images/avatar.png" alt="" /></span>
        <a href="javascript:;" @click="loginOut()" class="loginOut"><i class="iconfont icon-tuichu"></i></a>
      </div>
    </header>
    <el-container>
      <div>
        <el-aside width="180px">
          <el-menu width="180px" :default-active="activePath" router>
            <el-submenu :index="item.id + ''" v-for="item in menuList" :key="item.id">
              <!-- 一级菜单 -->
              <template slot="title">
                <i :class="iconsObj[item.id]"></i>
                <span>{{ item.title }}</span>
              </template>
              <el-menu-item :index="subItem.path" v-for="subItem in item.children" :key="subItem.id">
                <div v-if="subItem.title == '黑名单'">
                  <span style="color: red; font-weight: bold" @click="activePaths(subItem.path)">{{ subItem.title }}</span>
                </div>
                <div v-else>
                  <span @click="activePaths(subItem.path)">{{ subItem.title }}</span>
                </div>
              </el-menu-item>
            </el-submenu>
          </el-menu>
        </el-aside>
      </div>
      <el-main>
        <div class="content_main">
          <!-- 检查需要缓存的组件 -->
          <keep-alive :include="pageCacheList">
            <router-view v-if="$route.meta.keepAlive" />
          </keep-alive>
          <!-- 不需要缓存的组件 -->
          <router-view v-if="!$route.meta.keepAlive" />
        </div>
      </el-main>
    </el-container>
    <el-dialog class="positiveDialog" @close="close" ref="positiveDialog" :modal="false" title="近三天转内正人员" :visible.sync="positiveDialog" width="390px">
      <div class="positive_box">
        <p v-if="positiveList.length <= 0">暂无转正人员</p>
        <p v-for="(item, index) in positiveList" :key="index">
          <span>{{ item.pername }}</span> {{ item.trial_period_end }}
        </p>
      </div>
      <el-button class="lightBlueBtn searchBtn" type="primary" size="small" @click="close()">确认</el-button>
    </el-dialog>
  </div>
</template>

<script>
  import { getSelectDepId } from '@/api/common.js'
  import { loginOut } from '@/api/login'
  import { recentlyCorrected } from '@/api/personnelList.js'
  import { depList, getUserMenu } from '@/api/user.js'
  import { mapGetters } from 'vuex'
  export default {
    name: 'Layout',
    data() {
      return {
        menuList: [],
        depList: [],
        depData: null,
        activePath: '/personnel/personnelList',
        iconsObj: {
          2: 'iconfont icon-renyuan',
          12: 'iconfont icon-zhaopinxinxi',
          20: 'iconfont icon-shouye',
          24: 'iconfont icon-xiangmuxiaoxi',
        },
        positiveDialog: true,
        positiveList: [],
      }
    },
    created() {
      this.getUserMenu()
      this.getDepList()
      this.getRecentlyCorrected()
      this.activePath = window.sessionStorage.getItem('activePath')
      if (window.sessionStorage.getItem('positiveDialog') === 'false') {
        this.positiveDialog = false
      }
    },
    methods: {
      async getUserMenu() {
        let res = await getUserMenu({ hidden: 0 })
        this.menuList = res.list
      },
      async getDepList() {
        let res = await depList()
        this.depList = res.list
        try {
          const userInfo = JSON.parse(sessionStorage.getItem('userInfo') || '{}')
          const deps = (userInfo.deps || '')
            .split(',')
            .map((id) => Number(id))
            .filter(Boolean) // 清除 NaN 或空字符串

          this.depList = this.depList.filter((item) => deps.includes(Number(item.did)))
        } catch (e) {
          console.error('解析用户信息失败:', e)
          this.depList = [] // 或者保留原始 depList
        }
        if (sessionStorage.getItem('selectDep')) {
          this.depData = Number(sessionStorage.getItem('selectDep'))
        } else {
          this.depData = (sessionStorage.getItem('deps') || '').split(',')[0] || this.depList[0]?.did
          sessionStorage.setItem('selectDep', this.depData)
        }
      },
      async getRecentlyCorrected() {
        let { data } = await recentlyCorrected()
        this.positiveList = data
      },
      activePaths(val) {
        window.sessionStorage.setItem('activePath', val)
      },
      close() {
        this.positiveDialog = false
        window.sessionStorage.setItem('positiveDialog', 'false')
      },
      async changeDepList(val) {
        this.depData = val
        window.sessionStorage.setItem('selectDep', val)
        // 重新获取项目id
        let re = await getSelectDepId({ select_dep: val })
        // 刷新当前页
        this.$router.go(0)
      },
      async loginOut() {
        let res = await loginOut()
        if (res.status === 200) {
          window.sessionStorage.clear()
          this.$router.push('/login')
          // location.reload()
          this.$message.success(res.msg)
        }
      },
    },
    computed: {
      ...mapGetters({
        pageCacheList: 'pageCache/getPageCacheList',
      }),
      pageCache() {
        return this.pageCacheList.join(',')
      },
    },
  }
</script>
<style lang="less">
  .home {
    .header {
      height: 60px;
      background: #015293;
      top: 0;
      left: 0;
      right: 0;
      z-index: 99;
      box-shadow: 0 0 6px #e5e5e5;
      -webkit-transition: height 0.5s;
      transition: height 0.5s;
      position: relative;

      .logo {
        position: absolute;
        left: 0;
        width: 230px;
        height: 50px;
        -webkit-transition: width 0.5s, height 0.5s, margin-top 0.5s;
        transition: width 0.5s, height 0.5s, margin-top 0.5s;
        margin: 15px 0 0 14px;
      }
      .selectDep {
        width: 150px;
        margin: 15px 0 0 14px;
        font-size: 14px;
        color: #fff;
        background-color: #015293;
        border-color: #015293;
        position: absolute;
        left: 250px;
        .el-input__inner {
          padding-left: 10px;
          color: #fff;
          font-size: 16px;
          background-color: #015293;
          border-color: #015293;
          // 禁止文字选中
          -webkit-user-select: none;
          -moz-user-select: none;
          -o-user-select: none;
          -khtml-user-select: none;
          -webkit-user-select: none;
          -ms-user-select: none;
          user-select: none;
          &:focus {
            border-color: #015293;
            box-shadow: none;
          }
        }
        .el-input__suffix {
          left: -150px;
          color: #fff;
        }
      }
      .loginbar {
        float: right;
        margin: 20px 30px 0 0;
        font-size: 14px;
        line-height: 21px;
        display: flex;
        align-items: center;
        .break {
          margin-top: -1px;
          transform: rotate(180deg);
          &:hover {
            i {
              display: block;
              transform: rotate(180deg);
            }
          }
          margin-right: 25px;
          i {
            display: block;
            transition: all 1s;
            font-size: 22px;
          }
        }
        .iconfont {
          font-size: 20px;
        }
        .username {
          font-size: 14px;
          color: #fff;
          margin-right: 20px;
          display: flex;
          align-items: center;
          > img {
            padding-left: 10px;
          }
        }
        .loginOut {
          transform: rotate(180deg);
        }
        a {
          display: inline-block;
          color: #fff;
        }
        .role {
          transition: all 0.5s;
          margin-right: 25px;

          &:hover {
            transform: scale(0.9);
          }
        }
      }
    }
    .el-container {
      > div {
        background-color: #fff;
      }
      .el-aside {
        position: relative;
        height: calc(100vh - 60px);
        > ul {
          padding-top: 10px;
        }
        .el-menu {
          border-right: 0;
          height: 100%;
          background: #fff;
          -webkit-user-select: -moz-none;
          -moz-user-select: none;
          -o-user-select: none;
          -khtml-user-select: none;
          -webkit-user-select: none;
          -ms-user-select: none;
          user-select: none;
          .el-submenu__title {
            box-sizing: border-box;
            border-left: 3px solid #ffffff;
            &:hover {
              background-color: #e8f2f9 !important;
              color: #015293 !important;
              border-left: 3px solid #015293;
            }
            font-size: 16px;
            .iconfont {
              margin-right: 8px;
            }
          }
          .el-submenu {
            &:nth-of-type(2) {
              > div {
                padding-left: 16px !important;
              }
              .iconfont {
                font-size: 24px;
                margin-right: 3px;
              }
            }
            &:nth-of-type(1),
            &:nth-of-type(4) {
              .iconfont {
                font-size: 14px;
              }
            }
            &:nth-of-type(1) {
              > div {
                padding-left: 21px !important;
              }
            }
          }
          .el-menu-item {
            width: 180px;
            min-width: 180px;
            box-sizing: border-box;
            border-left: 3px solid #ffffff;
            &:hover {
              background-color: #e8f2f9 !important;
              color: #015293 !important;
              border-left: 3px solid #015293;
            }
          }
          .el-menu-item.is-active {
            background-color: #f5f7fa !important;
          }
        }
      }
      .el-main {
        background: #eee;
        padding-right: 15px;
        padding-bottom: 15px;
        padding-top: 15px;
        padding-left: 15px;
        .content_main {
          background-color: #fff;
          padding-top: 15px;
          padding-left: 15px;
          padding-right: 15px;
          padding-bottom: 1px;
          min-height: calc(100vh - 90px);
        }
      }
    }
    .positiveDialog {
      .el-dialog__header {
        border-bottom: 1px solid #dcdfe6;
      }
      .el-dialog__body {
        padding: 20px;
        padding-bottom: 28px;
      }
      .positive_box {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        > p {
          margin-bottom: 10px;
          span {
            margin-right: 10px;
          }
          width: 50%;
          &:nth-of-type(2n) {
            padding-left: 15px;
          }
        }
      }
      .searchBtn {
        width: 112px;
        display: block;
        margin: 0 auto;
        margin-top: 10px;
      }
    }
  }
</style>
